// ** Icons Import
import { Calendar, CheckSquare, FileText, Grid } from 'react-feather'
import {
  IS_ADMIN,
  IS_MENTOR,
  IS_RESOURCE,
  IS_SALES
} from '../../utility/constants'

export default [
  {
    id: 'dashboards',
    title: 'Dashboard',
    icon: <Grid size={20} />,
    badge: 'light-warning',
    navLink: '/dashboard',
    show: [IS_ADMIN, IS_MENTOR, IS_RESOURCE, IS_SALES]
  },
  {
    id: 'reviewRoster',
    title: 'Review Roster',
    icon: <Calendar size={20} />,
    badge: 'light-warning',
    navLink: '/review-roster',
    show: [IS_ADMIN, IS_MENTOR]
  },
  {
    id: 'myTopic',
    title: 'My Topic',
    icon: <FileText size={20} />,
    navLink: '/apps/myTopic',
    show: [IS_RESOURCE]
  },
  {
    id: 'myTask',
    title: 'My Task',
    icon: <CheckSquare size={20} />,
    navLink: '/apps/myTask',
    show: [IS_RESOURCE]
  }
]
